const useAuthorization = () => {
  const addAuthorizationHeader = (header: Record<string, unknown>, tokenType: string, accessToken: string): void => {
    header.Authorization = `${tokenType} ${accessToken}`;
  };

  return { addAuthorizationHeader };
};

export default useAuthorization;
